module.exports = __webpack_public_path__ + "img/loading.e36dc7fe.gif";